import React from 'react'
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info-circle.svg'
import { formatMoney } from '../../../../utils/formatters'

export const INFO_DETAILS = {
  title: 'Importante',
  subtitle: 'Entenda os valores',
  icon: <InfoIcon />
}

export const WEEKDAYS = [
  { index: '2', name: 'Segundas' },
  { index: '3', name: 'Terças' },
  { index: '4', name: 'Quartas' },
  { index: '5', name: 'Quintas' },
  { index: '6', name: 'Sextas' },
  { index: '7', name: 'Sábados' },
  { index: '1', name: 'Domingos' }
]

export const getCharts = (data, sameDate) => {
  const weekdayBillings = WEEKDAYS.map(day => {
    const dayData = data.weeklyBilling.find(data => data.dayOfWeek === day.index)
    return { label: day.name, value: dayData?.total || 0 }
  })
  const maxData = Math.max(...weekdayBillings.map(item => item.value))
  const bestIncomeDays = weekdayBillings.filter(day => day.value === maxData).map(day => day.label)
  const lastDay = bestIncomeDays.pop()
  const bestIncomeText = bestIncomeDays.join(', ') + (bestIncomeDays.length ? ' e ' : '') + lastDay
  return {
    title: <>Os <strong>dias de melhor faturamento</strong> {sameDate ? 'neste' : 'no'} mês: {bestIncomeText}</>,
    subtitle: `${formatMoney(data.professionalsAmount.monthTotalBalance)} é o faturamento bruto do mês`,
    data: weekdayBillings
  }
}
